import Content from '../../content.js';

namespace('IO.Views.Locations', function (exports) {
  'use strict';

  var Index = Content.extend({
    beforeFilter: function () {
      this.tableContainer = $('#locations-table-container');
    },
    render: function () {
      this.bindRowClick();
    },
    afterRender: function () {
      let init = new Initializer();

      this.tableContainer.on('htmx:afterSwap', () => {
        init.register();
        this.bindRowClick();
      });
    },
    bindRowClick: function () {
      this.tableContainer
        .find('.paginated-table tbody')
        .on('click', 'tr', function () {
          Turbolinks.visit($(this).attr('href'));
        });
    },
  });

  exports.Index = Index;
});
